import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { adminAuthExchangeImpersonationCode } from '@pro-sto/api-client';
import { authStore } from '@/stores/AuthStore';
import { toastStore } from '@/stores/ToastStore';
import { ROUTES } from '@/constants/routes';
import './AuthImpersonatePage.css';

const AuthImpersonatePage: React.FC = observer(() => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;

    const code = searchParams.get('code');
    if (!code) {
      toastStore.showError('Код авторизации отсутствует');
      navigate(ROUTES.AUTH_PHONE, { replace: true });
      return;
    }

    let cancelled = false;

    (async () => {
      try {
        const response = await adminAuthExchangeImpersonationCode({
          requestBody: { code },
        });
        if (cancelled) return;
        authStore.setSession(response);
        navigate(ROUTES.ORDERS, { replace: true });
      } catch (error) {
        console.error('Impersonation exchange failed:', error);
        if (cancelled) return;
        toastStore.showError('Не удалось войти в панель сервисного центра');
        navigate(ROUTES.AUTH_PHONE, { replace: true });
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [searchParams, navigate]);

  return (
    <div className="auth-impersonate-page" data-testid="auth-impersonate-page">
      <p className="auth-impersonate-page__text">Выполняется вход в панель СЦ…</p>
    </div>
  );
});

AuthImpersonatePage.displayName = 'AuthImpersonatePage';
export default AuthImpersonatePage;
